import { render, staticRenderFns } from "./ProviderSelection.vue?vue&type=template&id=ddf4fe3a&scoped=true&"
import script from "./ProviderSelection.vue?vue&type=script&lang=js&"
export * from "./ProviderSelection.vue?vue&type=script&lang=js&"
import style0 from "./ProviderSelection.vue?vue&type=style&index=0&id=ddf4fe3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf4fe3a",
  null
  
)

export default component.exports